<template>
  <div class="customer-components">
    <MyModal @close="closeModal" v-if="modal">
      <!-- default スロットコンテンツ -->
      <div class="iframe-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/5V9MYPCxHWY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <!-- /default -->
    </MyModal>
    <div class="customer">
      <div class="head-wrapper">
        <div class="jumbotron">
          <img src="../../assets/img/job/customer/jumbotron.jpg" alt="" class="over_display">
          <img src="../../assets/img/job/customer/jumbotron_under.jpg" alt="" class="under_display">
        </div>
        <div class="message-tile">
          <div class="message-tile-inner">
            <div class="message">
              <img src="../../assets/img/job/customer/catch.png" alt="接した人に笑顔を。受付として店舗のムードをつくってます。" width="390px">
            </div>
            <div class="movie-button" @click="openModal">
              <img src="../../assets/img/job/movie_button.png" alt="1分で仕事を見る" width="360px">
            </div>
          </div>
        </div>
      </div>
      <div class="main-contents">
        <div class="type-section">
          <FukidashiTitle title="どんなタイプの先輩がいる？" />
          <TypeAnswer genre="customer" message="周りの人から頼られたり、<br>助けたりするのが好きな人。"/>
        </div>
        <div class="type-section">
          <FukidashiTitle title="1日でお客様と接する時間は？" />
          <Graph graphNumber="95" />
          <div class="details">
            <p>
            お客様係は、スーパーの受付といえるポジション。定位置はサービスカウンターです。「あの商品はどの売場にありますか」というようなお客様の問い合わせ窓口でもあるので、売場のレイアウトはもちろん、おおまかな品揃えも頭の中に入れています。
            </p>
            <p>
            店内放送や宅急便の受け付け、贈答品のラッピングも行います。レジ業務を行うパートさんのマネジメントも大切な仕事。忙しい時間帯は、私自身もヘルプでレジに入ります。
            </p>
            <p>
            人が相手だから、臨機応変な対応を求められる仕事はいろいろ。ひとつの作業をしながら、周りの状況を見渡す広い視野が身につきました。そんな私が心掛けているのは、どんな状況でも笑顔を忘れないことです。誰かに頼られたら気持ちよく応えたい。それで、感謝の言葉をいただけると、「よし、またがんばろう」って思えるんです。
            </p>
          </div>
        </div>
        <ScheduleLink />
      </div>
    </div>
  </div>
</template>

<script>
import MyModal from '@/components/MyModal.vue'
import FukidashiTitle from '@/components/job/FukidashiTitle.vue'
import TypeAnswer from '@/components/job/TypeAnswer.vue'
import Graph from '@/components/job/Graph.vue'
import ScheduleLink from '@/components/job/ScheduleLink.vue'
export default {
  name: 'Customer',
  components: {
    MyModal,
    FukidashiTitle,
    TypeAnswer,
    Graph,
    ScheduleLink
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false
    },
  }
}
</script>
<style scoped lang="scss">
.iframe-wrapper{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56%;
  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.customer {
  padding-bottom: 100px;
  margin: 0 auto;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.head-wrapper {
  position: relative;
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
}
.message-tile {
  position: absolute;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  transform: translateX(-25%);
  @media print, screen and (max-width: 960px) {
    transform: translateX(0);
    width: 50%;
  }
}
.message-tile-inner {
  position: relative;
}
.movie-button {
  position: absolute;
  bottom: 30px;
  right: -30px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  @media print, screen and (max-width: 960px) {
    right: -5px;
  }
  &:hover {
    opacity: 0.5;
  }
  img {
    vertical-align: middle;
  }
}
.main-contents {
  margin: 0 auto;
  margin-top: 100px;
  max-width: 750px;
  width: 100%;
  @media print, screen and (max-width: 750px) {
    width: 90%;
  }
}
.type-section + .type-section {
  margin-top: 100px;
}
.details {
  font-size: 12px;
  line-height: 2em;
  margin-top: 50px;
}
</style>
